import EvolucionVentasTotales from './EvolucionVentasTotales';
import EvolucionVentasCumplimiento from './EvolucionVentasCumplimiento';
import EvolucionVentasDesgloseMes from './EvolucionVentasDesgloseMes';
import { useState } from 'react';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import { registerLocale } from 'react-datepicker';
import DatePickerYear from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import es from 'date-fns/locale/es';
import { PageTitle } from '../../../../_metronic/layout/core';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import * as Utilities from '../../../Components/Utils/Utils';

export default function EvolucionVentas({ title }) {

    registerLocale('es', es);

    const animatedComponents = makeAnimated();
    const [unidadEconomica, setUnidadEconomica] = useState(Utilities.getListUnidadesEconomicas().list[0]);
    let unidadesEconomicasList = Utilities.getListUnidadesEconomicas();

    const getOptionValue = idDefault => {
        return unidadesEconomicasList.list.filter(obj => obj.value === idDefault)
    }

    const onChangeGraphType = (inputValue) => {
        //setEnableQuery(true); //Everytime the select changes, it enables the useQuery condition for CharFromServer
        setUnidadEconomica(inputValue);
    }

    const dYear = new Date();
    // dYear.setFullYear(año1.getFullYear());
    const [dateMes, setDateMes] = useState(dYear);
    const [dateMesTemp, setDateMesTemp] = useState(dYear);

    const [año1, setAño1] = useState(new Date());
    let dateFormated1 = (dateMes) ? año1.getFullYear() : dateMesTemp.getFullYear();

    const d = new Date();
    // const year = d.getFullYear();
    const month = d.getMonth();
    const day = d.getDate();

    const [año2, setAño2] = useState(new Date(Utilities.getAnioComparativo(), month, day));
    let dateFormated2 = año2.getFullYear();


    let dateFormatedMes = (dateMes) ? (dateMes.getMonth() + 1) : (dateMesTemp.getMonth() + 1);
    let dateStringdMes = Utilities.monthFullNames[dateFormatedMes - 1];

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.EVOLUCION_VENTAS]} >
                <PageTitle>
                    {title} - Últimos 12 meses

                </PageTitle>


                <div className="card">
                    <div className="card-header border-0 pt-6 row g-3 flex-wrap d-flex flex-row">

                        <div className="col-12 col-sm-4">
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Mall:</div>
                            <Select
                                classNamePrefix='filter'
                                components={animatedComponents}
                                defaultValue={getOptionValue(unidadesEconomicasList.defaultId)}
                                isMulti={false}
                                closeMenuOnSelect={true}
                                options={unidadesEconomicasList.list}
                                onChange={(onChangeGraphType)}
                            />
                        </div>
                        <div className='col-12 col-sm-4'>
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Mes Cierre:</div>
                            <DatePickerYear
                                className="form-control form-control-transparent pe-5"
                                locale="es"
                                selected={dateMes}
                                onChange={(dateX) => dateX && setDateMes(dateX)}
                                dateFormat="MM/yyyy"
                                showMonthYearPicker
                                maxDate={new Date()}
                            />
                        </div>
                        <div className='col-12 col-sm-4'>
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Año Comparativo:</div>
                            <DatePickerYear
                                className="form-control form-control-transparent pe-5"
                                locale="es"
                                selected={año2}
                                onChange={(dateX) => dateX && setAño2(dateX)}
                                dateFormat="yyyy"
                                showYearPicker
                                minDate={Utilities.add_years(new Date(), -6)}
                                maxDate={new Date()}
                            />
                        </div>

                    </div>

                    <div className="card-body ">
                        
                    </div>
                </div>


                <h3 className="fw-bolder me-5 my-1 pt-7 pb-2">Ventas Año Actual
                </h3>
                <div className="card my-5">
                    <div className="card-body tab-content pt-0 mt-10">
                        <EvolucionVentasTotales unidadEconomicaId={unidadEconomica.value} mesCierre={dateFormatedMes} anio={dateFormated1 - 1}></EvolucionVentasTotales>
                    </div>
                </div>


                <h3 className="fw-bolder me-5 my-1 pt-7 pb-2">Ventas Año Anterior
                </h3>
                <div className="card my-5">
                    <div className="card-body tab-content pt-0 mt-10">
                        <EvolucionVentasTotales unidadEconomicaId={unidadEconomica.value} mesCierre={dateFormatedMes} anio={dateFormated2 - 1}></EvolucionVentasTotales>
                    </div>
                </div>


                <h3 className="fw-bolder me-5 my-1 pt-7 pb-2">Cumplimiento
                </h3>
                <div className="card my-5">
                    <div className="card-body tab-content pt-0 mt-10">
                        <EvolucionVentasCumplimiento unidadEconomicaId={unidadEconomica.value} mesCierre={dateFormatedMes} anio1={dateFormated1 - 1} anio2={dateFormated2 - 1}></EvolucionVentasCumplimiento>
                    </div>
                </div>

                <h3 className="fw-bolder me-5 my-1 pt-7 pb-2">Desglose de {dateStringdMes}, {(dateFormated1)}
                </h3>
                <div className="card my-5">
                    <div className="card-body tab-content pt-0 mt-10">
                        <EvolucionVentasDesgloseMes unidadEconomicaId={unidadEconomica.value} mesCierre={dateFormatedMes} anio={dateFormated1 - 1}></EvolucionVentasDesgloseMes>
                    </div>
                </div>
            </PermissionsGate>
        </>
    )
}